import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";
import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetMerchflows_merchflowId_S0_s0UserTriggerId_ =
  "/merchflows/:merchflowId/s0/:s0UserTriggerId";

export type ParamsGetMerchflows_merchflowId_S0_s0UserTriggerId_ = ExtractRouteParams<
  typeof RouteGetMerchflows_merchflowId_S0_s0UserTriggerId_
>;

export type ResponseGetMerchflows_merchflowId_S0_s0UserTriggerId_ = ({
  s0_solution_id: number;
  template_code: string;
} & (
  | { status: "NOT_STARTED" | "IN_PROGRESS" }
  | {
      status: "ERROR";
      error: object;
    }
  | {
      status: "DONE";
      solution: PogNonCircular;
    }
))[];
